import styled from 'styled-components';
import SVG from '@components/1-atoms/SVG';

export const AppWrapper = styled.div`
  display: flex;
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  background: ${({ theme }) => theme.colors.background};
`;

export const MainContent = styled.main`
  flex: 1;
  overflow: auto;
  background: ${({ theme }) => theme.colors.background};
`;

export const SVGSprite = styled(SVG).attrs({ name: 'icons-sprite', uniquifyIDs: false })`
  position: absolute;
  width: 0;
  height: 0;
  visibility: hidden;
`;
